const apiBaseUrl = process.env.GATSBY_API_URL

export { apiBaseUrl }
